import { ErrorHandler, Injectable } from "@angular/core";
import { NGXLogger } from "ngx-logger";


@Injectable()
export class SSErrorHandler extends ErrorHandler {

    constructor(
        private readonly _logger: NGXLogger
    ) {

        super()
    }

    override handleError(error: any): void {
        this._logger.error(error);
        super.handleError(error)
    }
}